import { ActionType, Experiment } from './model';
import { AbTestName, getExperimentById, getExperimentByName } from 'utils/abTests';
import { WlWindow } from 'typings/globals/cordova';

declare const window: WlWindow;

export type ExperimentActions = {
  setExperimentVariant(experimentId: number, variant: number): void;
  assignExperimentVariant(experimentName: string): void;
}

function getRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function getStoredExperiments(): Experiment[] {
  try {
    return JSON.parse(window.localStorage.getItem('ab-experiments')) || [];
  } catch (e) {
    return [];
  }
}

function checkIfExperimentAlreadyIsAssigned(experimentId) {
  const experiments = getStoredExperiments();
  return experiments.some(exp => exp.id === experimentId);
}

function actionsFactory(dispatch: (action: ActionType) => void): ExperimentActions {
  return {
    setExperimentVariant(experimentId, variant) {
      const experiment = getExperimentById(experimentId);
      if (experiment.enabled) {
        dispatch({ type: 'SET_EXPERIMENT_VARIANT', payload: { variant, experimentId: experimentId } });
      }
    },
    assignExperimentVariant(experimentName: AbTestName) {
      const experiment = getExperimentByName(experimentName);
      if (experiment.enabled) {
        const isAlreadyAssigned = checkIfExperimentAlreadyIsAssigned(experiment.id);
        if (isAlreadyAssigned) {
          return;
        }
        const variant = getRandom(0, experiment.variants.length);
        dispatch({ type: 'SET_EXPERIMENT_VARIANT', payload: { variant, experimentId: experiment.id } });
      }
    },
  };
}

export default actionsFactory;
